import { Outlet } from "react-router-dom";
import {
  AppBar,
  Box,
  CssBaseline,
  Toolbar,
  useTheme,
  styled,
} from "@mui/material";

// Component imports
import FrontHeader from "components/frontheader";
import FrontFooter from "components/footer";

const Main = styled("main")(({ theme }: any) => ({
  ...theme.typography.mainContent,
  flex: 1, // This makes the main content take up the available space
  marginLeft: 0,
  borderBottomLeftRadius: 0,
  borderBottomRightRadius: 0,
  width: "100%", // Adjusted width to take full space
}));

const FrontLayout = () => {
  const theme = useTheme();

  const renderAppBar = () => (
    <AppBar
      enableColorOnDark
      position="fixed"
      color="inherit"
      elevation={0}
      sx={{ bgcolor: theme.palette.background.default }}
    >
      <Toolbar>
        <FrontHeader />
      </Toolbar>
    </AppBar>
  );

  const renderFooter = () => (
    <Box component="footer" sx={{ width: "100%", py: 2, mt: "auto" }}>
      <CssBaseline />
      <Toolbar>
        <FrontFooter />
      </Toolbar>
    </Box>
  );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column", // Stack content vertically
        minHeight: "80vh", // Ensure the layout covers the full height
      }}
    >
      <CssBaseline />
      {renderAppBar()}
      <Toolbar /> {/* Add space below AppBar */}
      <Main>
        <Outlet />
      </Main>
      {renderFooter()}
    </Box>
  );
};

export default FrontLayout;
